/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './search-az.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/search.service';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '../shared/utils.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/router/src/router';
import * as import13 from '../shared/search-elasticsearch.service';
import * as import14 from '@angular/core/src/metadata/view';
import * as import15 from '@angular/core/src/linker/component_factory';
import * as import16 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import17 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import18 from '../shared/map-to-iterable.pipe';
import * as import19 from '@angular/core/src/linker/template_ref';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/common/src/directives/ng_for';
import * as import22 from '@angular/common/src/directives/ng_if';
import * as import23 from '../shared/loading-indicator.ngfactory';
import * as import24 from '../shared/loading-indicator';
import * as import25 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import26 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import27 from '@angular/common/src/directives/ng_class';
import * as import28 from '@angular/core/src/security';
export class Wrapper_SearchAZComponent {
  context:import0.SearchAZComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.SearchAZComponent(p0,p1,p2,p3,p4,p5);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_0 = currValue;
    }
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_1 = currValue;
    }
  }
  check_title(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.title = currValue;
      this._expr_2 = currValue;
    }
  }
  check_target(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.target = currValue;
      this._expr_3 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_SearchAZComponent_Host:import4.RenderComponentType = (null as any);
class _View_SearchAZComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _SearchAZComponent_0_4:Wrapper_SearchAZComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent_Host0,renderType_SearchAZComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'search-az',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_SearchAZComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchAZComponent_0_4 = new Wrapper_SearchAZComponent(this.parentInjector.get(import8.SearchService),new import9.ElementRef(this._el_0),this.parentInjector.get(import10.UtilsService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import12.Router),this.parentInjector.get(import13.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchAZComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._SearchAZComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchAZComponent) && (0 === requestNodeIndex))) { return this._SearchAZComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchAZComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchAZComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_SearchAZComponent_Host === (null as any))) { (renderType_SearchAZComponent_Host = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_SearchAZComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const SearchAZComponentNgFactory:import15.ComponentFactory<import0.SearchAZComponent> = new import15.ComponentFactory<import0.SearchAZComponent>('search-az',viewFactory_SearchAZComponent_Host0,import0.SearchAZComponent);
const styles_SearchAZComponent:any[] = ([] as any[]);
var renderType_SearchAZComponent:import4.RenderComponentType = (null as any);
class _View_SearchAZComponent0 extends import3.AppView<import0.SearchAZComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import16.Wrapper_NgFor;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _anchor_29:any;
  /*private*/ _appEl_29:import5.AppElement;
  _TemplateRef_29_5:any;
  _NgIf_29_6:import17.Wrapper_NgIf;
  _text_30:any;
  _text_31:any;
  _anchor_32:any;
  /*private*/ _appEl_32:import5.AppElement;
  _TemplateRef_32_5:any;
  _NgIf_32_6:import17.Wrapper_NgIf;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  /*private*/ _expr_48:any;
  _pipe_mapToIterable_0:import18.MapToIterable;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent0,renderType_SearchAZComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_48 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_1 = import2.createRenderElement(this.renderer,parentRenderNode,'p',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._text_3 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1,(null as any));
    this._appEl_5 = new import5.AppElement(5,1,this,this._anchor_5);
    this._TemplateRef_5_5 = new import19.TemplateRef_(this._appEl_5,viewFactory_SearchAZComponent1);
    this._NgFor_5_6 = new import16.Wrapper_NgFor(this._appEl_5.vcRef,this._TemplateRef_5_5,this.parentInjector.get(import20.IterableDiffers),this.ref);
    this._text_6 = this.renderer.createText(this._el_1,'\n\n    ',(null as any));
    this._text_7 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,parentRenderNode,'div',new import2.InlineArray4(4,'class','pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main','id','modal-popup'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n\n        ',(null as any));
    this._el_10 = import2.createRenderElement(this.renderer,this._el_8,'span',new import2.InlineArray2(2,'class','slider-subtitle5 black-text no-margin-bottom'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'A-Z',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n\n        ',(null as any));
    this._el_13 = import2.createRenderElement(this.renderer,this._el_8,'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_15 = import2.createRenderElement(this.renderer,this._el_13,'div',new import2.InlineArray2(2,'class','row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_15,'div',new import2.InlineArray2(2,'class','col-md-11 col-sm-10 center-col text-center margin-ten no-margin-top xs-margin-bottom-seven'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                    ',(null as any));
    this._el_19 = import2.createRenderElement(this.renderer,this._el_17,'h6',new import2.InlineArray2(2,'class','no-margin-top margin-ten xs-margin-bottom-seven'),(null as any));
    this._el_20 = import2.createRenderElement(this.renderer,this._el_19,'strong',new import2.InlineArray2(2,'class','black-text'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_17,'\n                ',(null as any));
    this._text_23 = this.renderer.createText(this._el_15,'\n            ',(null as any));
    this._text_24 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_25 = import2.createRenderElement(this.renderer,this._el_13,'div',new import2.InlineArray2(2,'class','row az-content center-col'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n                ',(null as any));
    this._el_27 = import2.createRenderElement(this.renderer,this._el_25,'div',new import2.InlineArray2(2,'class','col-md-12 col-sm-10 center-col'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n\n                    ',(null as any));
    this._anchor_29 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_29 = new import5.AppElement(29,27,this,this._anchor_29);
    this._TemplateRef_29_5 = new import19.TemplateRef_(this._appEl_29,viewFactory_SearchAZComponent2);
    this._NgIf_29_6 = new import17.Wrapper_NgIf(this._appEl_29.vcRef,this._TemplateRef_29_5);
    this._text_30 = this.renderer.createText(this._el_27,'\n\n                    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_27,'\n                    ',(null as any));
    this._anchor_32 = this.renderer.createTemplateAnchor(this._el_27,(null as any));
    this._appEl_32 = new import5.AppElement(32,27,this,this._anchor_32);
    this._TemplateRef_32_5 = new import19.TemplateRef_(this._appEl_32,viewFactory_SearchAZComponent3);
    this._NgIf_32_6 = new import17.Wrapper_NgIf(this._appEl_32.vcRef,this._TemplateRef_32_5);
    this._text_33 = this.renderer.createText(this._el_27,'\n                    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_27,'\n                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_25,'\n            ',(null as any));
    this._text_36 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_37 = this.renderer.createText(this._el_8,'\n\n    ',(null as any));
    this._text_38 = this.renderer.createText(parentRenderNode,'\n    ',(null as any));
    this._pipe_mapToIterable_0 = new import18.MapToIterable();
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._anchor_29,
      this._text_30,
      this._text_31,
      this._anchor_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import21.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    if (((token === import19.TemplateRef) && (29 === requestNodeIndex))) { return this._TemplateRef_29_5; }
    if (((token === import22.NgIf) && (29 === requestNodeIndex))) { return this._NgIf_29_6.context; }
    if (((token === import19.TemplateRef) && (32 === requestNodeIndex))) { return this._TemplateRef_32_5; }
    if (((token === import22.NgIf) && (32 === requestNodeIndex))) { return this._NgIf_32_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_5_0_0:any = this.context.fields;
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_29_0_0:boolean = !this.context.ready;
    this._NgIf_29_6.check_ngIf(currVal_29_0_0,throwOnChange,false);
    this._NgIf_29_6.detectChangesInInputProps(this,this._anchor_29,throwOnChange);
    const currVal_32_0_0:any = this.context.ready;
    this._NgIf_32_6.check_ngIf(currVal_32_0_0,throwOnChange,false);
    this._NgIf_32_6.detectChangesInInputProps(this,this._anchor_32,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_48:any = import2.interpolate(1,'\n                        ',this.context.title,'');
    if (import2.checkBinding(throwOnChange,this._expr_48,currVal_48)) {
      this.renderer.setText(this._text_21,currVal_48);
      this._expr_48 = currVal_48;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_SearchAZComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.SearchAZComponent> {
  if ((renderType_SearchAZComponent === (null as any))) { (renderType_SearchAZComponent = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,styles_SearchAZComponent,{})); }
  return new _View_SearchAZComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent1,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'a',new import2.InlineArray4(4,'class','az-btn highlight-button btn-az btn btn-small no-margin-top modal-popup no-margin-bottom','href','#modal-popup'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = import2.interpolate(1,'\n        ',(this.parent.context.labels? this.parent.context.labels[this.context.$implicit][this.parent.context.language]: this.context.$implicit),' \n    ');
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onClickLoad(this.context.$implicit)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_SearchAZComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent2 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _LoadingIndicator_0_4:import23.Wrapper_LoadingIndicator;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent2,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'loading-indicator',new import2.InlineArray4(4,'class','tab-style1','color','#B6B6B6'),(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import23.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new import23.Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '#B6B6B6';
    this._LoadingIndicator_0_4.check_color(currVal_0_0_0,throwOnChange,false);
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import5.AppElement;
  _TemplateRef_10_5:any;
  _NgFor_10_6:import16.Wrapper_NgFor;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _anchor_20:any;
  /*private*/ _appEl_20:import5.AppElement;
  _TemplateRef_20_5:any;
  _NgFor_20_6:import16.Wrapper_NgFor;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _pipe_mapToIterable_0_0:any;
  _pipe_mapToIterable_0_1:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent3,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','tab-style1'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_2,'div',new import2.InlineArray2(2,'class','col-md-12 col-sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_6 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._el_7 = import2.createRenderElement(this.renderer,this._el_4,'ul',new import2.InlineArray2(2,'class','nav nav-tabs nav-tabs-light text-center'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_7,'\n                                    ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_7,(null as any));
    this._appEl_10 = new import5.AppElement(10,7,this,this._anchor_10);
    this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10,viewFactory_SearchAZComponent4);
    this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef,this._TemplateRef_10_5,this.parent.parentInjector.get(import20.IterableDiffers),this.parent.ref);
    this._text_11 = this.renderer.createText(this._el_7,'\n                                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','tab-content'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n\n                            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._anchor_20 = this.renderer.createTemplateAnchor(this._el_17,(null as any));
    this._appEl_20 = new import5.AppElement(20,17,this,this._anchor_20);
    this._TemplateRef_20_5 = new import19.TemplateRef_(this._appEl_20,viewFactory_SearchAZComponent5);
    this._NgFor_20_6 = new import16.Wrapper_NgFor(this._appEl_20.vcRef,this._TemplateRef_20_5,this.parent.parentInjector.get(import20.IterableDiffers),this.parent.ref);
    this._text_21 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_17,'\n\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._text_24 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_mapToIterable_0_0 = import2.pureProxy1((<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0.transform.bind((<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0));
    this._pipe_mapToIterable_0_1 = import2.pureProxy1((<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0.transform.bind((<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._anchor_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import21.NgFor) && (10 === requestNodeIndex))) { return this._NgFor_10_6.context; }
    if (((token === import19.TemplateRef) && (20 === requestNodeIndex))) { return this._TemplateRef_20_5; }
    if (((token === import21.NgFor) && (20 === requestNodeIndex))) { return this._NgFor_20_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_10_0_0:any = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_0,(<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0.transform)(this.parent.context.azData));
    this._NgFor_10_6.check_ngForOf(currVal_10_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    valUnwrapper.reset();
    const currVal_20_0_0:any = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_1,(<_View_SearchAZComponent0>this.parent)._pipe_mapToIterable_0.transform)(this.parent.context.azData));
    this._NgFor_20_6.check_ngForOf(currVal_20_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_20_6.detectChangesInInputProps(this,this._anchor_20,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent4 extends import3.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import25.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _map_6:any;
  /*private*/ _expr_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent4,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_6 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {active: p0};
    });
    this._expr_7 = import1.UNINITIALIZED;
    this._expr_8 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.parentInjector.get(import26.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'data-toggle','tab'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 4)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this._map_6((this.context.$implicit.key == this.parent.parent.context.requestType));
    this._NgClass_0_3.check_ngClass(currVal_0_0_0,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_7:any = import2.interpolate(1,'#tab-',this.context.$implicit.key,'');
    if (import2.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_2,'href',this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL,currVal_7));
      this._expr_7 = currVal_7;
    }
    const currVal_8:any = import2.interpolate(1,'\n                                                ',(this.parent.parent.context.labels? this.parent.parent.context.labels[this.context.$implicit.key][this.parent.parent.context.language]: this.context.$implicit.key),'');
    if (import2.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent5 extends import3.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import25.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import5.AppElement;
  _TemplateRef_10_5:any;
  _NgFor_10_6:import16.Wrapper_NgFor;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _anchor_18:any;
  /*private*/ _appEl_18:import5.AppElement;
  _TemplateRef_18_5:any;
  _NgFor_18_6:import16.Wrapper_NgFor;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_33:any;
  _map_34:any;
  _pipe_mapToIterable_0_2:any;
  _pipe_mapToIterable_0_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent5,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_33 = import1.UNINITIALIZED;
    this._map_34 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {active: p0};
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','tab-pane med-text fade in'),(null as any));
    this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.parentInjector.get(import26.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_2,'div',new import2.InlineArray4(4,'class','col-md-12 col-sm-12 center-col text-center','id','animated-tab'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_5,'ul',new import2.InlineArray2(2,'class','nav nav-tabs nav-tabs-light text-center'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._appEl_10 = new import5.AppElement(10,8,this,this._anchor_10);
    this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10,viewFactory_SearchAZComponent6);
    this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef,this._TemplateRef_10_5,this.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.ref);
    this._text_11 = this.renderer.createText(this._el_8,'\n                                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._text_14 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._el_15 = import2.createRenderElement(this.renderer,this._el_5,'div',new import2.InlineArray2(2,'class','tab-content tab-content-az-names'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._anchor_18 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_18 = new import5.AppElement(18,15,this,this._anchor_18);
    this._TemplateRef_18_5 = new import19.TemplateRef_(this._appEl_18,viewFactory_SearchAZComponent7);
    this._NgFor_18_6 = new import16.Wrapper_NgFor(this._appEl_18.vcRef,this._TemplateRef_18_5,this.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.ref);
    this._text_19 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_15,'\n\n\n                                        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_5,'\n                                        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_5,'\n                                    ',(null as any));
    this._text_23 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_mapToIterable_0_2 = import2.pureProxy1((<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0.transform.bind((<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0));
    this._pipe_mapToIterable_0_3 = import2.pureProxy1((<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0.transform.bind((<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._anchor_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import21.NgFor) && (10 === requestNodeIndex))) { return this._NgFor_10_6.context; }
    if (((token === import19.TemplateRef) && (18 === requestNodeIndex))) { return this._TemplateRef_18_5; }
    if (((token === import21.NgFor) && (18 === requestNodeIndex))) { return this._NgFor_18_6.context; }
    if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 25)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = 'tab-pane med-text fade in';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_34((this.context.$implicit.key == this.parent.parent.context.requestType));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_10_0_0:any = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_2,(<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0.transform)(this.context.$implicit.value));
    this._NgFor_10_6.check_ngForOf(currVal_10_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    valUnwrapper.reset();
    const currVal_18_0_0:any = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_3,(<_View_SearchAZComponent0>this.parent.parent)._pipe_mapToIterable_0.transform)(this.context.$implicit.value));
    this._NgFor_18_6.check_ngForOf(currVal_18_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NgFor_18_6.detectChangesInInputProps(this,this._anchor_18,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_33:any = import2.interpolate(1,'tab-',this.context.$implicit.key,'');
    if (import2.checkBinding(throwOnChange,this._expr_33,currVal_33)) {
      this.renderer.setElementProperty(this._el_0,'id',currVal_33);
      this._expr_33 = currVal_33;
    }
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent5(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent6 extends import3.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import25.Wrapper_NgClass;
  _el_1:any;
  _text_2:any;
  _map_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent6,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_4 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {active: p0};
    });
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',new import2.InlineArray2(2,'class','nav az-letter'),(null as any));
    this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.parent.parentInjector.get(import26.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._el_1 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'data-toggle','tab'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 2)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'nav az-letter';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_4((this.context.index == 0));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_5:any = import2.interpolate(2,'#tab-',this.parent.context.$implicit.key,'-',this.context.$implicit.key,'');
    if (import2.checkBinding(throwOnChange,this._expr_5,currVal_5)) {
      this.renderer.setElementProperty(this._el_1,'href',this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL,currVal_5));
      this._expr_5 = currVal_5;
    }
    const currVal_6:any = import2.interpolate(1,'',this.context.$implicit.key,'');
    if (import2.checkBinding(throwOnChange,this._expr_6,currVal_6)) {
      this.renderer.setText(this._text_2,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent6(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent7 extends import3.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import25.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import5.AppElement;
  _TemplateRef_10_5:any;
  _NgFor_10_6:import16.Wrapper_NgFor;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  /*private*/ _expr_26:any;
  _map_27:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent7,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_26 = import1.UNINITIALIZED;
    this._map_27 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {active: p0};
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','col-md-9 col-sm-12 text-center center-col tab-pane fade in'),(null as any));
    this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.parent.parentInjector.get(import26.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'class','tab-pane fade in'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_2,'div',new import2.InlineArray2(2,'class','row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                                        ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_4,'div',new import2.InlineArray2(2,'class','col-md-12 col-sm-12 gray-text'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                                            ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_6,'ul',new import2.InlineArray2(2,'class','az-list'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                                                ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._appEl_10 = new import5.AppElement(10,8,this,this._anchor_10);
    this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10,viewFactory_SearchAZComponent8);
    this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef,this._TemplateRef_10_5,this.parent.parent.parent.parentInjector.get(import20.IterableDiffers),this.parent.parent.parent.ref);
    this._text_11 = this.renderer.createText(this._el_8,'\n                                                            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n                                                        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n                                                    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._el_15 = import2.createRenderElement(this.renderer,this._el_2,'div',new import2.InlineArray2(2,'class','row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                                        ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_15,'div',new import2.InlineArray2(2,'class','wide-separator-line'),(null as any));
    this._text_18 = this.renderer.createText(this._el_15,'\n                                                    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_2,'\n                                                    ',(null as any));
    this._text_20 = this.renderer.createText(this._el_2,'\n                                                ',(null as any));
    this._text_21 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import21.NgFor) && (10 === requestNodeIndex))) { return this._NgFor_10_6.context; }
    if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 21)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'col-md-9 col-sm-12 text-center center-col tab-pane fade in';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_27((this.context.index == 0));
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_10_0_0:any = this.context.$implicit.value;
    this._NgFor_10_6.check_ngForOf(currVal_10_0_0,throwOnChange,false);
    this._NgFor_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_26:any = import2.interpolate(2,'tab-',this.parent.context.$implicit.key,'-',this.context.$implicit.key,'');
    if (import2.checkBinding(throwOnChange,this._expr_26,currVal_26)) {
      this.renderer.setElementProperty(this._el_0,'id',currVal_26);
      this._expr_26 = currVal_26;
    }
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchAZComponent7(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_SearchAZComponent8 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  /*private*/ _expr_6:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchAZComponent8,renderType_SearchAZComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                                    ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'class','popup-modal-dismiss pointer'),(null as any));
    this._el_3 = import2.createRenderElement(this.renderer,this._el_2,'span',new import2.InlineArray2(2,'class','label label-az-name'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                                                ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_6:any = import2.interpolate(1,'',this.context.$implicit,'');
    if (import2.checkBinding(throwOnChange,this._expr_6,currVal_6)) {
      this.renderer.setText(this._text_4,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.parent.context.onSelect(this.parent.parent.context.$implicit.key,this.context.$implicit)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_SearchAZComponent8(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchAZComponent8(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/search-az.component.ngfactory.ts